import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '../tokens/api.token';
import { AuthService } from './auth.service';

export interface ErrorReportPayload {
  error_message: string;
  stack_trace?: string;
  module?: string;
  route_path?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  private baseApiUrl = inject(API_URL, { optional: true }) ?? 'https://api.suitelifetools.com';
  private apiUrl = `${this.baseApiUrl}/errors`;

  logError(payload: ErrorReportPayload): void {
    // 1. Check user consent gate (e.g., localStorage setting for error reporting opt-in)
    const isErrorLoggingOptedIn = localStorage.getItem('error_reporting_opt_in') === 'true';
    if (!isErrorLoggingOptedIn) return;

    const user = this.auth.currentUser();
    const body = {
      sub: user?.id || null,
      error_message: payload.error_message,
      stack_trace: payload.stack_trace || null,
      module: payload.module || 'unknown',
      route_path: payload.route_path || window.location.pathname,
    };

    // 2. Post error payload asynchronously without blocking the UI
    this.http.post(this.apiUrl, body).subscribe({
      error: (err) => {
        // Fallback safety: Log silently to console if network call fails
        console.debug('Failed to report error to backend:', err);
      },
    });
  }
}
